
import {Alert} from 'rsuite';

export function handleErrorStatusCode(axiosError, operationNameOrStatusCodeToErrorMessageMap, customHandlerIfErrorNotHanlded, alwaysExecuteErrorhandler, rethrowError){
	let errorWasHandled =  false;
	const operationName =  typeof operationNameOrStatusCodeToErrorMessageMap === "string"?operationNameOrStatusCodeToErrorMessageMap: null;
	const statusCodeToErrorMessageMap = typeof operationNameOrStatusCodeToErrorMessageMap !== "string"?operationNameOrStatusCodeToErrorMessageMap: null;
	try{
		if(502 === axiosError.response.status){
			if(statusCodeToErrorMessageMap && statusCodeToErrorMessageMap[502]){
				Alert.error(statusCodeToErrorMessageMap[502], 5000);
				errorWasHandled = true;
			}else{
				Alert.error(`Something went wrong on our side${operationName?" on " +operationName:""}. Please try again!`, 5000);
				errorWasHandled = true;
			}

		}
	}catch(error){
		console.error(error);
	}
	if(!errorWasHandled && customHandlerIfErrorNotHanlded){
		const result =  customHandlerIfErrorNotHanlded(axiosError);
		if(!alwaysExecuteErrorhandler){
			return result;
		}
	}
	if(alwaysExecuteErrorhandler){
		return alwaysExecuteErrorhandler(axiosError);
	}
	if(rethrowError){
		throw axiosError;
	}
}

export function createErrorStatusCodeHandler(operationNameOrStatusCodeToErrorMessageMap, customHandlerIfErrorNotHanlded, alwaysExecuteErrorhandler , rethrowError){
	return (axiosError)=>{
		return handleErrorStatusCode(axiosError, operationNameOrStatusCodeToErrorMessageMap,customHandlerIfErrorNotHanlded, alwaysExecuteErrorhandler, rethrowError);
	}
}

